/* React Higher Order Component which fetches template data where template product = props.product
    Child (InnerComponent) will only render once project data is successfully fetched.
    child will receive props: {
        product: PropTypes.string,
        templateStoreState: PropTypes.shape({ initialized: PropTypes.bool, template: PropTypes.object, ... })
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const get = require('lodash/get');
const uuid = require('uuid');

const TemplateActions = require('../../actions/TemplateActions');
const TemplateStore = require('../../stores/template_store_reflux');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    product: PropTypes.string,
    activityStoreState: PropTypes.object,
    hideLoadingIcon: PropTypes.bool
};

const defaultProps = {
    product: '',
    activityStoreState: null,
    hideLoadingIcon: false
};

export default function withTemplateData(WrappedComponent) {
    class WithTemplateData extends React.Component {
        constructor(props) {
            super(props);

            this._getStateFromStore = this._getStateFromStore.bind(this);
            this.state = {
                fatalError: null,
                ...this._getStateFromStore(),
            };

            this.unsubscribes = [TemplateStore.listen(this.onTemplateStoreChange.bind(this))];
        }

        UNSAFE_componentWillMount() {
            // Templates are fetched during initial client loading. Do not re-fetch
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        _getStateFromStore() {
            let templateStoreState = null;
            let fatalError = null;
            const productFromActStore = get(this.props.activityStoreState, 'activity.product', null);
            if (!!this.props.product) {
                templateStoreState = TemplateStore.getStateTemplateByProduct(this.props.product);
            }
            else if (!!productFromActStore) {
                templateStoreState = TemplateStore.getStateTemplateByProduct(productFromActStore);
            }
            else {
                const errText = 'WithTemplateData missing props.product or props.activityStoreState';
                fatalError = errText;
            }

            return { templateStoreState: templateStoreState, fatalError: fatalError };
        }

        onTemplateStoreChange(state) {
            this.setState(this._getStateFromStore());
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} allowStackTrace={false}/>;
            }

            if (!this.state.templateStoreState.initialized) {
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }

            return (
                <WrappedComponent
                    {...this.props}
                    templateStoreState={this.state.templateStoreState}
                />
            );
        }
    }

    WithTemplateData.propTypes = propTypes;
    WithTemplateData.defaultProps = defaultProps;
    WithTemplateData.displayName = `WithTemplateData(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithTemplateData;
}
